module.exports = __webpack_public_path__ + "img/template5.6031175a.png";